"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mui = require("tss-react/mui");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _Menu = require("../Menu");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useStyles = (0, _mui.makeStyles)()(function () {
  return {
    menuList: {
      overflow: 'auto'
    }
  };
});

/** Used internally by the ContextMenu component */
var MobileContextMenu = function MobileContextMenu(_ref) {
  var onToggle = _ref.onToggle,
    children = _ref.children,
    open = _ref.open;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  return /*#__PURE__*/_react["default"].createElement(_material.SwipeableDrawer, {
    anchor: "bottom",
    open: open,
    onClose: onToggle,
    onOpen: onToggle,
    disableSwipeToOpen: true,
    minFlingVelocity: 250
  }, /*#__PURE__*/_react["default"].createElement(_Menu.MenuList, {
    autoFocusItem: open,
    className: classes.menuList
  }, children));
};
MobileContextMenu.propTypes = {
  onToggle: _propTypes["default"].func,
  children: _propTypes["default"].node.isRequired,
  open: _propTypes["default"].bool
};
MobileContextMenu.defaultProps = {
  open: false,
  onToggle: undefined
};
var _default = MobileContextMenu;
exports["default"] = _default;